import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { NotebookPenIcon } from 'lucide-react'
import { useTheme } from '@mui/material/styles'
import { NoteEntityRef, NotesApi } from '../../api/NotesApi'
import { NoteEditorDialog } from './NoteEditorDialog'

export type EntityNoteType = 'issue' | 'warrant' | 'convertible'

const notesApi = new NotesApi()

const toEntityRef = (entityId: string, type: EntityNoteType): NoteEntityRef => {
    if (type === 'issue') return { issueId: entityId }
    if (type === 'warrant') return { warrantId: entityId }
    return { convertibleId: entityId }
}

export const EntityNoteButton = ({ entityId, type }: { entityId: string; type: EntityNoteType }) => {
    const { t } = useTranslation()
    const theme = useTheme()
    const [open, setOpen] = useState(false)
    const [hasNote, setHasNote] = useState(false)

    const entityRef = toEntityRef(entityId, type)

    useEffect(() => {
        const ref = toEntityRef(entityId, type)

        void (async () => {
            try {
                const note = await notesApi.getNote(ref)
                setHasNote(!!note?.content?.trim())
            } catch (err) {
                console.error(err)
            }
        })()
    }, [entityId, type])

    return (
        <>
            <Tooltip title={t('pages.notes.editor.tooltip')}>
                <span>
                    <IconButton aria-label={t('pages.notes.editor.ariaLabel')} onClick={() => setOpen(true)}>
                        <NotebookPenIcon
                            color={theme.palette.primary.main}
                            fill={hasNote ? theme.palette.primary.main : 'transparent'}
                            fillOpacity={hasNote ? 1 : 0}
                            size={22}
                        />
                    </IconButton>
                </span>
            </Tooltip>
            <NoteEditorDialog
                entityRef={entityRef}
                onClose={() => setOpen(false)}
                onDeleted={() => setHasNote(false)}
                onSaved={() => setHasNote(true)}
                open={open}
            />
        </>
    )
}
